import { Button as AntButton } from 'antd';
import { FC, ReactNode } from 'react';
import { ButtonProps } from 'antd/lib/button';

type Props = ButtonProps & {
  children?: ReactNode;
  style?: object;
  onClick?: (e: any) => void;
};

export const Button: FC<Props> = (props) => {
  return <AntButton {...props}>{props.children}</AntButton>;
};

export default Button;
